<script setup lang="ts">
import type { ExperiencePreference, ExperienceQuality } from '../lib/experience'
import { primaryLogoUrl } from '../lib/brand'

defineProps<{
  quality: ExperienceQuality
  preference: ExperiencePreference
}>()

defineEmits<{
  cycleQuality: []
}>()

const qualityLabels: Record<ExperienceQuality, string> = {
  high: '高质',
  balanced: '均衡',
  lite: '轻量',
}
</script>

<template>
  <header class="site-header">
    <a class="brand-lockup" href="#top" aria-label="返回 SE Universe 首屏">
      <img :src="primaryLogoUrl" alt="" width="44" height="44" />
      <span>
        <strong>SE UNIVERSE</strong>
        <small>FRESHMAN DIGITAL 2026</small>
      </span>
    </a>
    <nav class="site-nav" aria-label="主要导航">
      <a href="#lifecycle">软件如何诞生</a>
      <a href="#growth">四年成长</a>
      <a href="#careers">职业传送门</a>
      <a href="#series">系列计划</a>
    </nav>
    <button
      class="quality-control"
      type="button"
      :aria-label="`动效档位：${qualityLabels[quality]}，点击切换`"
      @click="$emit('cycleQuality')"
    >
      <span class="quality-control__signal" aria-hidden="true">
        <i /><i /><i :class="{ muted: quality === 'lite' }" />
      </span>
      {{ preference === 'auto' ? `自动·${qualityLabels[quality]}` : qualityLabels[quality] }}
    </button>
  </header>
</template>
